import { Action } from '../shared/common.action';
import { AiAction } from './ai.actions';
import { AiState } from './ai.models';
import { Utils } from '../shared';

export default function reducer(state = new AiState(), action: Action): AiState {

  switch (action.type) {

    case AiAction.ANALYSE: {
      return <AiState> state.withMutations(s => s
        .updateIn(['isBusy'], () => 1)
      );
    }

    case AiAction.ANALYSE_SUCCESS: {
      return <AiState> state.withMutations(s => s
        .updateIn(['isBusy'], () => 0)
      );
    }

    case AiAction.SIMILARITY: {
      return <AiState> state.withMutations(s => s
        .updateIn(['isBusy'], () => 1)
      );
    }

    case AiAction.SIMILARITY_SUCCESS: {
      return <AiState>Utils.updateDiff(state, action)
        .updateIn(['isBusy'], (isBusy: number) => Utils.decrementIsBusy(action, isBusy));
    }

    case AiAction.SIMILARITY_FAILED: {
      return <AiState>Utils.updateDiff(state, action)
        .updateIn(['isBusy'], (isBusy: number) => Utils.decrementIsBusy(action, isBusy));
    }

    default:
      return state;
  }
}
